module.exports = __webpack_public_path__ + "static/media/awards-1.94e37695.png";